/******************** TEST ********************/
/*import React from 'react';
import ReactDOM from 'react-dom';*/
/******************** TEST ********************/
import Tools from '../../../base/components/tools';

/******************** BUILD ********************/
import less from '../index.less';
/******************** BUILD ********************/

class HistoricoNoticias extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      configurations: {},
      newsType: 'Destacada',
      homePage: 'Salud',
      newsData: []
    };

    if (_spPageContextInfo.webTitle == 'Consorcio Salud') {
      this.page = 'salud'
    } else if (_spPageContextInfo.webTitle == 'Plan Complementario') {
      this.page = 'PC'
    } else if (_spPageContextInfo.webTitle == 'Servicios Premium') {
      this.page = 'Premium Individual'
    } else if (_spPageContextInfo.webTitle == 'Servicios Premium Empresarial') {
      this.page = 'Premium Empresa'
    }
    else {
      this.page = 'PBS';
    }


    this.pnpService = new ServicioPnp();
    this.setDateFormat = this.setDateFormat.bind(this);
    this.tools = new Tools();
  }

  componentDidMount() {
    const configurations = {};
    const homePage = this.page;
    const contentType = this.tools.setContentType();
    const url = 'ObtenerNoticiasHistorico?home=' + homePage + '&contenido=' + contentType;


    this.pnpService.getList('parametrosPaginas', (list) => {
      list.forEach((item) => {
        configurations[item.CSNombreText] = item.CSValorNote == 'false' ? false : item.CSValorNote;
        configurations[item.CSNombreText + 'CSVisibleBool'] = item.CSVisibleBool;
      });
      this.setState({ configurations: configurations });
    }, (this.page == 'PBS' ? "CSFormularioChoice eq 'Home PBS'" : (this.page == 'PC' ? "CSFormularioChoice eq 'Home PC'" : (this.page == 'Premium Individual' ? "CSFormularioChoice eq 'Premium Individual'" : (this.page == 'Premium Empresarial') ? "CSFormularioChoice eq 'Premium Empresa'" : "CSFormularioChoice eq 'Home Salud'"))));

    const news = new ServicioProxy(url, 'ServicioConsorcioHomes.svc');
    news.getElements('POST', {}).then((response) => {
      const data = JSON.parse(response);
      this.setState({ newsData: data });
    }).catch(error => {
      //this.setState({ });
    });


  }


  setDateFormat(date) {
    const dateFormated = moment(date).format('MMMM D', true);
    return dateFormated;
  }

  render() {
    return (
      <div className="news-container">
        <div className="row">
          <div className="col-md-6 title-new">
            <h2>{this.state.configurations['NoticiasTitulo']}</h2>
          </div>
        </div>
        <div className="row">
          <section>
            {
              !!this.state['newsData'] && this.state['newsData'].length > 0 ?
                [
                  this.state['newsData'].map((itemNews, key) => {
                    return (
                      <div className="article-container historical-article">
                        <article className={itemNews['Tipo'] === 'General' ? 'general-news-container' : 'outstanding-news-container'}>
                          {
                            itemNews['Tipo'] === 'Destacada' ?
                              <div className="col-md-6 col-xs-12 container-image" >
                                {!!itemNews['Inicio'] ?
                                  <p className="news-date">
                                    {this.setDateFormat(itemNews['Inicio'])}
                                  </p> : null
                                }
                                <a href={itemNews.Link ? itemNews.Link : '#'}>
                                  <div dangerouslySetInnerHTML={{ __html: itemNews.ContenidoDigital }} />
                                </a>
                              </div>
                              : ''
                          }
                          <div className={'container-text ' + (itemNews['Tipo'] === 'Destacada' ? 'col-md-6 col-xs-12' : '')}>
                            {itemNews['Tipo'] === 'General' && !!itemNews['Inicio'] ?
                              <p className="news-date">
                                {this.setDateFormat(itemNews['Inicio'])}
                              </p> : null
                            }
                            <a href={itemNews.Link ? itemNews.Link : '#'}>{itemNews.Tema}</a>
                            <h3>
                              <a href={itemNews.Link ? itemNews.Link : '#'}>{itemNews.Titulo}</a>
                            </h3>
                            <div className="summary">
                              <p dangerouslySetInnerHTML={{ __html: itemNews.Resumen }} ></p>
                            </div>
                          </div>
                        </article>
                        {
                          itemNews['Tipo'] === 'General' ?
                            <div className="div-container">
                              <hr className="news-division" />
                            </div> : ''
                        }
                      </div>
                    )
                  })
                ]
                : ''
            }
          </section>
        </div>
      </div>
    );
  }
}

const appId = document.getElementById('news-historical');
ReactDOM.render(<HistoricoNoticias />, appId);


// WEBPACK FOOTER //
// ./home/historicoNoticias/src/index.js